module.exports = __webpack_public_path__ + "media/images/shadow-3d71a6057d8dbdf0e09f9fbe15d3f4cd.png";